import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ReportsService } from 'src/app/features/reports/reports.service';
import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-transaction-summary-smart',
  template: `<app-transaction-summary [realtime]="realtime"
  [summary]="summary"
  [startDate]="startDate"
  [endDate]="endDate"></app-transaction-summary>`,
  styles: [
  ]
})
export class TransactionSummarySmartComponent extends FeaturesBaseComponent
  implements OnInit, OnDestroy {
  realtime: any = [];
  summary: any = [];
  endDate: any;
  startDate: any;

  constructor(private reportsService: ReportsService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    let dt = new Date();

    this.startDate = formatDate(
      new Date(),
      "yyyy-MM-dd",
      "en"
    );
    this.endDate = formatDate(new Date(), "yyyy-MM-dd", "en");
    let params: any = new HttpParams()
      .set("startDate", this.startDate)
      .set("endDate", this.endDate);

    this.reportsService.getrealtimeSummary(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
      }
    });

    this.reportsService.getrealtime(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.realtime = resData;
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
